module.exports = __webpack_public_path__ + "img/1513858374.cff1e8ba.jpg";